import { render, staticRenderFns } from "./LView.vue?vue&type=template&id=c06601f6&scoped=true&"
import script from "./LView.vue?vue&type=script&lang=js&"
export * from "./LView.vue?vue&type=script&lang=js&"
import style0 from "./LView.vue?vue&type=style&index=0&id=c06601f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06601f6",
  null
  
)

export default component.exports